import type { ProductFeedbackConsentState } from "@care-by-ella/contracts";

// TES-1106 — the patient page's product-feedback consent line: her current
// choice, the day she made it and the wording version she saw.
export function feedbackConsentLine(
  consent: ProductFeedbackConsentState | null,
): string {
  if (!consent) return "Inget samtycke till produktfeedback";
  const day = new Date(consent.decidedAt).toLocaleDateString("sv-SE", {
    timeZone: "Europe/Stockholm",
  });
  const what = consent.granted
    ? "Får kontaktas för produktfeedback"
    : "Har återkallat samtycke till produktfeedback";
  return `${what} ${day} (text ${consent.wordingVersion})`;
}
